import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import css from './UnlockableContent.module.css';
import SectionFieldArray from './SectionFieldArray';
import { Icons, PrimaryButton, SecondaryButton } from '../../../../../components';

const UnlockableContentModal = ({ type, isOpen, onClose, values, onSave, invalid }) => {
  const defaultContentType = type ? type.toLowerCase() : 'photos';
  const [activeContentType, setActiveContentType] = useState(defaultContentType);
  const submitDisabled = invalid;
  // Add this useEffect to update activeContentType when type prop changes
  useEffect(() => {
    if (type) {
      setActiveContentType(type.toLowerCase());
    }
  }, [type]);

  if (!isOpen) return null;

  const tabs = [
    {
      icon: 'images',
      id: 'photos',
      labelId: 'UnlockableContentModal.photosTab',
      defaultMessage: 'Photos',
    },
    {
      icon: 'video',
      id: 'videos',
      labelId: 'UnlockableContentModal.videosTab',
      defaultMessage: 'Videos',
    },
    {
      icon: 'post',
      id: 'posts',
      labelId: 'UnlockableContentModal.postsTab',
      defaultMessage: 'Posts',
    },
  ];

  // Add these CSS classes to your module.css file if they don't exist
  const transitionStyles = {
    enter: css.sectionEnter || 'section-enter',
    enterActive: css.sectionEnterActive || 'section-enter-active',
    exit: css.sectionExit || 'section-exit',
    exitActive: css.sectionExitActive || 'section-exit-active',
  };

  return (
    <div className={css.modalBackdrop}>
      <div className={css.modalContent}>
        <h3>
          <FormattedMessage
            id="UnlockableContentModal.title"
            defaultMessage="Add Unlockable Content"
          />
        </h3>
        <div className={css.tabContainer}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              type="button"
              className={activeContentType === tab.id ? css.activeTab : css.tab}
              onClick={() => setActiveContentType(tab.id)}
            >
              <Icons name={tab.icon} />{' '}
              <FormattedMessage id={tab.labelId} defaultMessage={tab.defaultMessage} />
            </button>
          ))}
        </div>
        <div className={css.tabContentContainer}>
          <TransitionGroup>
            <CSSTransition
              key={activeContentType}
              timeout={300}
              classNames={{
                enter: transitionStyles.enter,
                enterActive: transitionStyles.enterActive,
                exit: transitionStyles.exit,
                exitActive: transitionStyles.exitActive,
              }}
              unmountOnExit
            >
              <div className={css.sectionWrapper}>
                <SectionFieldArray
                  name={`unlockableContent.${activeContentType}`}
                  labelId={`UnlockableContentModal.${activeContentType}Label`}
                  onSave={onSave}
                  values={values}
                  activeContentType={activeContentType}
                />
              </div>
            </CSSTransition>
          </TransitionGroup>
        </div>
        <div className={css.modalActions}>
          <SecondaryButton onClick={() => onSave(values)} className={css.cancelButton}>
            <FormattedMessage id="UnlockableContentModal.close" defaultMessage="Cancel" />
          </SecondaryButton>
          <PrimaryButton
            onClick={() => onSave(values)}
            className={css.primaryButton}
            disabled={submitDisabled}
          >
            <FormattedMessage id="UnlockableContentModal.save" defaultMessage="Save" />
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default UnlockableContentModal;
